import { Fragment, useEffect } from 'react';
import Footer from '../../components/Footer';
import Header from '../../components/Header';
import InfinitProgressBar from '../../components/InfiniteProgressBar';
import PageHeader from '../../components/PageHeader';
import PageWrapper from '../../components/PageWrapper';
import ToolBarMenu from '../../components/ToolBarMenu';
import { useNewsList } from '../../queries/news';

const NewsDetail = () => {

    const NewsId = window.location.pathname.split("/").pop();
    const {data, error, loading} = useNewsList();
    if (error) return <div>error!</div>
    if (loading) return <InfinitProgressBar />
    if (!data) {
        return;
    }
    const myDomain = "src=\"" + process.env.REACT_APP_BASE_URL;
    const getImagesWithAbsolutePath = (text, absolutePathPrefix) => {
        if (!text) return ''
        const regex =  new RegExp(`(?:src=\"\/*)+(.*?)`, "g")
        return text.replace(regex,  absolutePathPrefix + '/$1')
    }
    const NewsBody = data.news.filter(x=> x.id == parseInt(NewsId)) ;

    return (
        <Fragment>

            {/* <ToolBarMenu/> */}

            <Header/>

            <PageHeader
                bgImg={NewsBody[0].bag.contentItems[0].image.urls[0]}
                title='اخبار و آگهی ها'
                content={NewsBody[0].displayText}
            />

            <PageWrapper classes={'product-details-wrapper sm-top'}>
                <div className="col-12">
                    <p dangerouslySetInnerHTML={{__html: getImagesWithAbsolutePath(NewsBody[0].newsBody.html, myDomain)}}/>
                </div>
            </PageWrapper>

            <br/>
            <br/>
            <br/>

            <Footer/>

        </Fragment>
    )
};

export default NewsDetail;